module.exports = __webpack_public_path__ + "img/LanceleauScreenshot3_1920x1080.1a250767.png";